export function PDFIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* File outline */}
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      
      {/* PDF text */}
      <text
        x="12"
        y="16.5"
        textAnchor="middle"
        fontSize="6"
        fill="currentColor"
        stroke="none"
      >
        PDF
      </text>
    </svg>
  );
}